const stats = [
  { value: "2,400+", label: "Happy Customers" },
  { value: "4.9/5", label: "Average Rating" },
  { value: "100+", label: "Cities Mapped" },
  { value: "Free", label: "Spring Shipping" },
];

const TrustSignals = () => {
  return (
    <section className="py-16 px-6 border-t" style={{ borderColor: "var(--brand-border)", backgroundColor: "var(--brand-card)" }}>
      <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {stats.map((stat) => (
          <div key={stat.label}>
            <div className="text-2xl mb-1" style={{ fontFamily: "var(--font-hero)", color: "var(--sage-400)" }}>
              {stat.value}
            </div>
            <div className="text-sm" style={{ color: "var(--brand-muted)", fontFamily: "var(--font-body)" }}>
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustSignals;
